import { GridColumn } from '@entity-framework/entity-grid/state/entity-grid-column';

export const pensionPaymentErrorsGridColumns = (): GridColumn[] => [
  {
    propertyName: 'errorId',
    headerLabel: 'Error ID',
    propertyType: 'text',
    sortable: true,
    colDefOverrides: {
      flex: 1,
      minWidth: 120
    }
  },
  {
    propertyName: 'errorDescription',
    headerLabel: 'Error Description',
    propertyType: 'text',
    sortable: true,
    formatForDisplay: (value: string) => value || '-',
    colDefOverrides: {
      flex: 3,
      minWidth: 300
    }
  }
];
